import icon from 'assets/img/icons/icon-warning.svg'

const MakeOfferFail = ({closeWindow}) => {
  return (
    <div className='modal-window__wrapper'>
    <header className="modal-window__header">
      <img src={icon} className="modal-window__icon" alt="" />
      <h5 className="modal-window__title">Something went wrong</h5>
      <p className="modal-window__info">Request has not been sent</p>
    </header>
    <footer className="modal-window__footer">
      <button className="modal-window__footer-close" onClick={closeWindow}>Done</button>
    </footer>
  </div>
  )
}

export default MakeOfferFail;
